import React from "react";
import { Box, Typography, Divider, TextField, Grid } from "@mui/material";
import BaseDrawer from "../../../UI/BaseDrawer/BaseDrawer";
import BaseCard from "../../../UI/BaseCard/BaseCard";

function ReveCardHistoryDetails({ open, handleCloseModal, cardDetails }) {

  console.log(cardDetails)

  const renderCategory = (title, fields) => (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ mb: 2, color: "#333", fontWeight: "bold" }}>
        {title}
      </Typography>
      <Grid container spacing={2}>
        {fields.map((field, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <TextField
              label={field.label}
              value={field.value || "N/A"}
              disabled
              variant="standard"
              fullWidth
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );

  return (
    <BaseDrawer open={open} handleClose={handleCloseModal} height="90vh" title="Card Details">
            <BaseCard>
                <Box sx={{ padding: "20px", mb: 4 }}>
                {/* Change Information */}
                {renderCategory("Change Information", [
                    { label: "Change Type", value: cardDetails?.changeType },
                    { label: "Change Date", value: cardDetails?.changeDate },
                ])}

                <Divider sx={{ my: 2, border: "1px solid #A6A6A6" }} />

                {/* Agent Information */}
                {renderCategory("Agent Information", [
                    { label: "Name", value: cardDetails?.agentName },
                    { label: "Username", value: cardDetails?.agentUsername },
                    { label: "User ID", value: cardDetails?.agentId },
                ])}

                <Divider sx={{ my: 2, border: "1px solid #A6A6A6" }} />

                {/* Customer Information */}
                {renderCategory("Customer Information", [
                    { label: "Name", value: cardDetails?.customerName },
                    { label: "Username", value: cardDetails?.customerUsername },
                    { label: "User ID", value: cardDetails?.customerId },
                ])}
                </Box>
            </BaseCard>
    </BaseDrawer>
  );
}

export default ReveCardHistoryDetails;
